import type { AnalyticDateFilter } from '~/presentation/ui';

import { useDateTimePickerContext } from '~/presentation/ui';
import { convertDateToTz } from '~/utils/dayjs';
import { useMemo } from 'react';

export const useMetricsTimeFilter = () => {
  const { dateTimePicked, compareDateTimePicked } = useDateTimePickerContext();

  const currentDates = useMemo<AnalyticDateFilter>(() => {
    return {
      startDate: convertDateToTz(dateTimePicked.since),
      endDate: convertDateToTz(dateTimePicked.until),
      alias: dateTimePicked.alias,
      title: dateTimePicked.title,
      since: dateTimePicked.since,
      until: dateTimePicked.until,
      versionId: dateTimePicked.versionId,
    };
  }, [dateTimePicked]);

  const compareCurrentDates = useMemo<AnalyticDateFilter>(() => {
    return {
      startDate: convertDateToTz(compareDateTimePicked.since),
      endDate: convertDateToTz(compareDateTimePicked.until),
      alias: compareDateTimePicked.alias,
    };
  }, [compareDateTimePicked]);

  // const previousDates = useMemo<AnalyticDateFilter>(() => {
  //   const offsetTime = convertDateToTz(dateTimePicked.until).diff(
  //     convertDateToTz(dateTimePicked.since),
  //     'day',
  //   );
  //   return {
  //     startDate: convertDateToTz(dateTimePicked.since)
  //       .subtract(offsetTime + 1, 'days')
  //       .startOf('day'),
  //     endDate: convertDateToTz(dateTimePicked.since).subtract(1, 'day').endOf('day'),
  //     alias: dateTimePicked.alias,
  //   };
  // }, [dateTimePicked.alias, dateTimePicked.since, dateTimePicked.until]);

  const getDatesArray = (since: number, until: number): number[] => {
    const dates: number[] = [];
    const startDate = convertDateToTz(since).startOf('day');
    const endDate = convertDateToTz(until).endOf('day');
    let currentDate = startDate;
    while (currentDate.isBefore(endDate, 'day') || currentDate.isSame(endDate, 'day')) {
      dates.push(currentDate.valueOf());
      currentDate = currentDate.add(1, 'day');
    }
    return dates;
  };

  const getDatesArrayFormat = (since: number, until: number, format?: string): string[] => {
    const dates: string[] = [];
    const startDate = convertDateToTz(since);
    const endDate = convertDateToTz(until);
    let currentDate = startDate;
    while (currentDate.isBefore(endDate, 'day')) {
      dates.push(currentDate.format(format));
      currentDate = currentDate.add(1, 'day');
    }
    return dates;
  };

  return {
    currentDates,
    previousDates: compareCurrentDates,
    dateTimePicked,
    compareCurrentDates,
    getDatesArray,
    getDatesArrayFormat,
  };
};
